import { IFooterModalData } from '@components/exportable/footer/interfaces/i-footer-modal-data'

const aboutText: string =
  'XMS allows the delivery of HR products and services.<br/>' +
  'It brings together core capabilities, such as order capture, authorisation, recruiting processes, '+
  'regulatory and compliance management, time keeping, invoicing and Management Information into a single' +
   'unified platform, through which range of world class products and services are delivered.'

const cookiesText: string = ' <h2>What is local storage?</h2>' +
  '"<p>Local storage is a web storage facility that allows websites to store data on a user`s device.</p>' +
  '<h2>How do we use local storage?</h2>' +
  '<ul>' +
	'<strong>How do we use cookies?</strong><br/>' +
  '<li class="local-storage-list-item"> <b>\'x3ui-css-filter\' (string)</b> for Display Adjustment Tool, name of current filter</li>' +
  '<li class="local-storage-list-item"> <b>\'x3ui-css-filters\' (object)</b> for Display Adjustment Tool, all filter values</li>' +
  '<li class="local-storage-list-item"> <b>\'x3ui-css-filters-switch\' (boolean)</b> for My Details &gt;' +
  'Account Settings, is Display Adjustment Tool switch enabled?</li>' +
  '<li class="local-storage-list-item"> <b>\'x3ui-css-filters-target\' (boolean)</b>' +
  'for Display Adjustment Tool, is \'Apply filters to images only\' checkbox enabled?</li>' +
  '      <li class="local-storage-list-item"> <b>\'x3ui-css-filters-location\' (Point)</b>' +
  'for Display Adjustment Tool, previous location of tool</li>\n' +
  '<li class="local-storage-list-item"> <b>{listTableId} (string)</b>' +
  '(session) stores the last loaded page number, allowing you to return to return the last page you were on</li>'

const termsText: string =
  'XMS is a private system operated by Reed Specialist Recruitment Ltd for its authorised clients.<br/>' +
  'Unauthorised access to this site is illegal according to the terms of the Computer Misuse Act (1990)'



// Value is default value on the footer items and corresponding modal. They will be repalced by actual translation.
export const modalData : IFooterModalData[] =
    [
      {
        title: {value: 'Terms', code: 'footer.terms.label'},
        body: {value: termsText, code: 'app.terms.text'},
        icon: 'description',
        width: '400px',
      },
      {
        title: {value: 'Privacy &amp; Cookies', code: 'footer.privacyAndCookies.label'},
        body: {value: cookiesText, code: 'app.cookies.text'},
        icon: 'shield',
        width: '750px',
      },
      {
        title: {value: 'About', code: 'footer.about.label'},
        body: {value: aboutText, code: 'app.cookies.about'},
        icon: 'info',
        width: '400px',
      },
    ]
